'use client'
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/eventList.ts
var EVENT_LIST_QUERY = `
id
title
subtitle
image11{${IMAGE_QUERY}}
image32{${IMAGE_QUERY}}
image31{${IMAGE_QUERY}}
slug
zone{id slug zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}}}
startingPrice
currencyCode
buttonLabel
cardButtonLabel
schedule{${SCHEDULE_QUERY}}
location{${LOCATION_QUERY}}
eventType
cmsTagsCollection(limit:5){ items {id} }
`;

export {
  EVENT_LIST_QUERY
};
//# sourceMappingURL=chunk-E577PGQH.mjs.map